import './contact.scss';
import { global_hooks } from 'src/globals';
import Dropdown from 'components/ui/dropdown/Dropdown';

let current_location = '';

global_hooks.on('init', () => {
	const select = document.getElementById('contact_location_select');
	if (!select) return;

	const dropdown = new Dropdown(select, { raw: true });

	dropdown.hooks.on('select', (option) => {
		current_location = option.value;
		set_gf_location(current_location);
	});

	// Pre-select the first location (also fills the gf_location field via the hook)
	const first = dropdown.options?.[0];
	if (first) dropdown.select(first);
});

// Re-apply the value after Gravity Forms re-renders (e.g. validation error / AJAX)
document.addEventListener('gform/post_render', () => {
	if (current_location) set_gf_location(current_location);
});

function set_gf_location(value) {
	const fields = document.querySelectorAll(
		'.gf_location input, .gf_location textarea, .gf_location select, input[name="location"]',
	);
	fields.forEach((field) => {
		field.value = value;
		field.dispatchEvent(new Event('input', { bubbles: true }));
		field.dispatchEvent(new Event('change', { bubbles: true }));
	});
}
